import { reject } from 'lodash/fp';
import { updateItem } from 'utils/fp';
import { PATH_BUILDER } from 'constants/actionTypes';

export default (ownerships = [], action) => {
  switch (action.type) {
    case PATH_BUILDER.OWNERSHIP.CREATE:
      return ownerships.concat(action.ownership);

    case PATH_BUILDER.OWNERSHIP.REMOVE:
      return reject({ id: action.id }, ownerships);

    case PATH_BUILDER.OWNERSHIP.UPDATE: {
      const { id, ...ownership } = action.ownership;
      return updateItem(ownerships, { id }, ownership);
    }

    default:
      return ownerships;
  }
};
